import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { BIOMETRIC_DEVICE_PROTOCOLS } from "@/lib/admin/biometricDevicesStore";
import { formatBiometricDeviceProtocol, type BiometricDeviceFormState } from "@/lib/admin/biometricDeviceForm";

type Props = {
  form: BiometricDeviceFormState;
  onChange: (patch: Partial<BiometricDeviceFormState>) => void;
};

export function BiometricDeviceUpsertFormFields({ form, onChange }: Props) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2 md:col-span-2">
        <Label className="text-xs text-muted-foreground">Model *</Label>
        <Input
          className="glass-input h-10"
          value={form.model}
          onChange={(e) => onChange({ model: e.target.value })}
          placeholder="e.g. ZKTeco K40"
          autoComplete="off"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">Driver</Label>
        <Input
          className="glass-input h-10"
          value={form.driver}
          onChange={(e) => onChange({ driver: e.target.value })}
          placeholder="e.g. zkteco, essl, hikvision"
          autoComplete="off"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">Protocol</Label>
        <Select value={form.protocol} onValueChange={(v) => onChange({ protocol: v as BiometricDeviceFormState["protocol"] })}>
          <SelectTrigger className="glass-input h-10">
            <SelectValue placeholder="Select protocol" />
          </SelectTrigger>
          <SelectContent>
            {BIOMETRIC_DEVICE_PROTOCOLS.map((p) => (
              <SelectItem key={p} value={p}>
                {formatBiometricDeviceProtocol(p)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2 md:col-span-2">
        <Label className="text-xs text-muted-foreground">Wrapper class</Label>
        <Input
          className="glass-input h-10"
          value={form.wrapperClass}
          onChange={(e) => onChange({ wrapperClass: e.target.value })}
          placeholder="PHP class that talks to the device"
          autoComplete="off"
        />
      </div>

      <div className="space-y-2 md:col-span-2">
        <Label className="text-xs text-muted-foreground">Description</Label>
        <Textarea
          className="glass-input min-h-[120px]"
          value={form.description}
          onChange={(e) => onChange({ description: e.target.value })}
          placeholder="Optional notes about this device type"
        />
      </div>
    </div>
  );
}
